import "./App.css";
import { Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import Header from "./components/Header";
import { styled } from "@mui/system";

const AppContainer = styled("div")({
  textAlign: "center",
});

function App() {
  return (
    <AppContainer>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </AppContainer>
  );
}

export default App;
